
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[id]",
      function () {
        return require("private-next-pages/companies/[id]/index.js");
      }
    ]);
  